export default "__VITE_ASSET__pzlwitxV__"